import React from 'react';

export default class Page9 extends React.Component {

    render() {

        const {pageData} = this.props;

        return <div id="region-main-pad">
            <div id="region-main"><span id="user-notifications"/>
                <div className="region-content">
                    <div role="main"><span id="maincontent"/>
                        <section>
                            <div className="">


                                <div className="ilead-rgt people">
                                    <div className="innerpadding">


                                        <div className="ilead-contentarea">


                                            <table width="100%" border="0" cellSpacing="0" cellPadding="0"
                                                   className="ilead_v_sport">
                                                <tbody>
                                                <tr>
                                                    <th width="25%" align="left" valign="top"
                                                        className="green_curve ">Development Goal:
                                                    </th>
                                                    <th width="37%" align="left" valign="top"
                                                        className="centerCont">3
                                                    </th>
                                                    <th width="37%" align="left" valign="top"
                                                        className=" green_curve1 centerCont">4
                                                    </th>
                                                </tr>
                                                <tr>
                                                    <td width="25%" align="left" valign="top"
                                                        className="lightgreen">
                                                        <div className="textAlignTable">Actions</div>
                                                    </td>
                                                    <td width="37%" align="left" valign="top"
                                                        className="lightgreen">
                                                        <textarea rows="3"
                                                                  className="textareaborder"
                                                                  cols="45"
                                                                  name="Actions3"
                                                                  value={pageData?.Actions?.Actions3}
                                                                  onChange={this.props.handleChangePageData('Actions')}/>
                                                    </td>
                                                    <td width="37%" align="left" valign="top"
                                                        className="lightgreen">
                                                        <textarea rows="3"
                                                                  className="textareaborder"
                                                                  cols="45"
                                                                  name="Actions4"
                                                                  value={pageData?.Actions?.Actions4}
                                                                  onChange={this.props.handleChangePageData('Actions')}/>
                                                    </td>
                                                </tr>
                                                <tr bgcolor="#feefd4">
                                                    <td width="25%" align="left" valign="top"
                                                        className="darkgreen">
                                                        <div className="textAlignTable">Timescales</div>
                                                    </td>
                                                    <td width="37%" align="left" valign="top"
                                                        className="lightgreen">
                                                        <textarea rows="3"
                                                                  className="textareaborder"
                                                                  cols="45"
                                                                  name="Timescales3"
                                                                  value={pageData?.Timescales?.Timescales3}
                                                                  onChange={this.props.handleChangePageData('Timescales')}/>
                                                    </td>
                                                    <td width="37%" align="left" valign="top"
                                                        className="lightgreen">
                                                        <textarea rows="3"
                                                                  className="textareaborder"
                                                                  cols="45"
                                                                  name="Timescales4"
                                                                  value={pageData?.Timescales?.Timescales4}
                                                                  onChange={this.props.handleChangePageData('Timescales')}/>
                                                    </td>
                                                </tr>
                                                <tr>
                                                    <td width="25%" align="left" valign="top"
                                                        className="lightgreen">
                                                        <div className="textAlignTable">Barriers</div>
                                                    </td>
                                                    <td width="37%" align="left" valign="top"
                                                        className="lightgreen">
                                                        <textarea rows="3"
                                                                  className="textareaborder"
                                                                  cols="45"
                                                                  name="Barriers3"
                                                                  value={pageData?.Barriers?.Barriers3}
                                                                  onChange={this.props.handleChangePageData('Barriers')}/>
                                                    </td>
                                                    <td width="37%" align="left" valign="top"
                                                        className="lightgreen">
                                                        <textarea rows="3"
                                                                  className="textareaborder"
                                                                  cols="45"
                                                                  name="Barriers4"
                                                                  value={pageData?.Barriers?.Barriers4}
                                                                  onChange={this.props.handleChangePageData('Barriers')}/>
                                                    </td>
                                                </tr>
                                                <tr bgcolor="#feefd4">
                                                    <td width="25%" align="left" valign="top"
                                                        className="darkgreen">
                                                        <div className="textAlignTable">Overcoming Barriers
                                                        </div>
                                                    </td>
                                                    <td width="37%" align="left" valign="top"
                                                        className="lightgreen">
                                                        <textarea rows="3"
                                                                  className="textareaborder"
                                                                  cols="45"
                                                                  name="OvercomingBarriers3"
                                                                  value={pageData?.OvercomingBarriers?.OvercomingBarriers3}
                                                                  onChange={this.props.handleChangePageData('OvercomingBarriers')}/>
                                                    </td>
                                                    <td width="37%" align="left" valign="top"
                                                        className="lightgreen">
                                                        <textarea rows="3"
                                                                  className="textareaborder"
                                                                  cols="45"
                                                                  name="OvercomingBarriers4"
                                                                  value={pageData?.OvercomingBarriers?.OvercomingBarriers4}
                                                                  onChange={this.props.handleChangePageData('OvercomingBarriers')}/>
                                                    </td>
                                                </tr>
                                                <tr>
                                                    <td width="25%" align="left" valign="top"
                                                        className="lightgreen">
                                                        <div className="textAlignTable">Resources</div>
                                                    </td>
                                                    <td width="37%" align="left" valign="top"
                                                        className="lightgreen">
                                                        <textarea rows="3"
                                                                  className="textareaborder"
                                                                  cols="45"
                                                                  name="Resources3"
                                                                  value={pageData?.Resources?.Resources3}
                                                                  onChange={this.props.handleChangePageData('Resources')}/>
                                                    </td>
                                                    <td width="37%" align="left" valign="top"
                                                        className="lightgreen">
                                                        <textarea rows="3"
                                                                  className="textareaborder"
                                                                  cols="45"
                                                                  name="Resources4"
                                                                  value={pageData?.Resources?.Resources4}
                                                                  onChange={this.props.handleChangePageData('Resources')}/>
                                                    </td>
                                                </tr>
                                                </tbody>
                                            </table>
                                            <div className="lightgreencontentbg keyquestionpad uiheading">
                                                <div className="border_subtitle">Learn from past experience
                                                </div>
                                                <p>Using the DEVELOPMENT model, identify things you didn’t do in
                                                    the past. Ensure these
                                                    are included next time when developing others.</p>
                                            </div>

                                            <div className="circle_title"><img
                                                src={require('@images/browndot.jpg')}
                                                alt=""/>NEXT STEPS
                                            </div>

                                            <p>Think about the following when you’re next planning someone’s
                                                development:</p>
                                            <div className="border_subtitle">Review your past performance</div>
                                            <p>How well have you developed your staff to date? What aspects of
                                                the DEVELOPMENT model did
                                                you adhere to? Did you collect appropriate information? Did you
                                                give the individual concerned a
                                                chance to make suggestions? Did you make sure they wrote down
                                                what they planned to do?</p>
                                            <div className="border_subtitle">Get feedback from the people you
                                                manage
                                            </div>
                                            <p>Ask the people you manage to give you feedback about the extent
                                                to which their development
                                                goals were agreed. Did you achieve a healthy balance between the
                                                business’s needs and those
                                                of the individual? Did you agree an agenda? Did you ask
                                                questions to encourage them to talk?
                                                Did you challenge their assumptions? Did you give your own
                                                views? Did you discuss their
                                                aspirations? Did you link their aspirations to business
                                                objectives?</p>


                                            <div className="left-btn">
                                                <div
                                                    onClick={this.props.handleChangePage('Page8')}
                                                    className="button-next-previous-done">&lt;&lt; Previous
                                                </div>
                                            </div>
                                            <div className="right-btn">
                                                <div onClick={this.props.savePageData('Page10')}
                                                     className="button-next-previous-done">Next &gt;&gt;</div>
                                            </div>


                                        </div>

                                    </div>


                                </div>


                            </div>
                        </section>
                    </div>
                </div>
            </div>
        </div>;
    }
}